import {Switch,Route, Redirect,useLocation} from 'react-router-dom'
import Layout1 from '../layouts/backend/Layout1'
import BlankLayout from '../layouts/BlankLayout';
import { useSelector } from "react-redux";
import { PrivateRoute } from './PrivateRoute';
import { PrivateRouteAuth } from './PrivateRoute-Auth';
import { motion } from "framer-motion";

const PageLayout = ({ children }) => children;

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
};

const pageTransition = {
  type: "tween",
  ease: "linear",
  duration: 0.5
};

const AnimationLayout = () => {
    const { pathname } = useLocation();
    return (
      <PageLayout>
        <motion.div
          key={pathname}
          initial="initial"
          animate="in"
          variants={pageVariants}
          transition={pageTransition}
        >
    
        </motion.div>
      </PageLayout>
    );
  };
const LayoutsRoute = props => {
    const { login, config } = useSelector((state) => state.auth);
    console.log(login)
    console.log(config)
    
    return (
        <Switch>
            <Route element={<AnimationLayout />}>
            <PrivateRouteAuth path="/auth" login={login}  component={BlankLayout} />
            {/* <PrivateRouteAuth path="/auth" login={login} exact component={BlankLayout} /> */}
            <Route path="/extra-pages" component={BlankLayout} />
            <PrivateRoute path="/" login={login}  component={Layout1} />
            </Route>
        </Switch>
    )
}

export default LayoutsRoute